var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{attrs:{"tab-position":"left"}},[_c('el-tab-pane',{attrs:{"label":"内网设置"}},[_c('inner-net-setting')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }